import axios from 'axios';
import qs from 'qs';
import cookie from '../../cookieHelper/cookie';

export default async function addPurchaseStory(data) {
    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/storyByPurchase`, qs.stringify(data), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)}`,
        },
    });
    if (String(response.data?.status?.code) !== '10200') {
        const error = new Error(response.data?.status?.message || 'Unable to add story.');
        error.response = response;
        throw error;
    }
    return response.data;
}
